function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ElementModel } from './ElementModel';
import * as Y from 'yjs';
import { deserializePath } from '../../utils/paperjs';
import { EditorConfig } from '../../edit/EditorConfig';
export class SegmentsModel extends ElementModel {
  get drawPoints() {
    if (this.localPoints.length >= 4) {
      return this.localPoints;
    }
    return this.points;
  }
  constructor(root, scope, type, liveCursor, isPerformanceMode) {
    super(root, scope, liveCursor, isPerformanceMode);
    _defineProperty(this, "item", null);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", true);
    _defineProperty(this, "shouldUseLocalPoints", true);
    _defineProperty(this, "localPointsPick", 24);
    if (this.root.doc && !this.root.has('type')) {
      this.root.set('type', type);
    }
    if (this.root.doc && !this.root.has('points')) {
      // points [minX, minY, width, height, radius]
      this.root.set('points', new Y.Array());
    }
  }
  subDispose() {}
  liveCursorPoint() {
    const yArray = this.root.get(ElementModel.KEYS.points);
    if (yArray.length < 2) {
      return null;
    }
    const point = new this.scope.Point(yArray.get(0), yArray.get(1));
    return point.transform(new this.scope.Matrix(this.pointsMatrix));
  }
  onVectorUpdate() {
    if (!this.item) {
      return;
    }
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    this.item.removeSegments();
    const next = deserializePath(this.drawPoints, this.scope, matrix);
    this.item.addSegments(next.segments);
    this.item.closePath();
  }
  createPaperItem() {
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    this.item = deserializePath(this.drawPoints, this.scope, matrix);
    this.item.strokeColor = new this.scope.Color(this.strokeColor);
    this.item.dashArray = this.dashArray;
    this.item.strokeWidth = this.strokeWidth;
    if (this.fillColor && this.fillColor.length > 0) {
      this.item.fillColor = new this.scope.Color(this.fillColor);
    }
    this.item.closePath();
  }
  editorConfig() {
    const cfg = new EditorConfig();
    return cfg;
  }
  vectorKeys() {
    return [];
  }
  styleKeys() {
    return {
      include: [],
      exclude: []
    };
  }
  onStyleKeyUpdate(_key) {}
}